import { useCallback } from 'react';

import { useMultipleQueryParamStates } from './useMultipleQueryParamStates';

type Args = {
  name: string;
};

export function useQueryParamState({
  name,
}: Args): [
  string | undefined,
  (value: string | undefined, options?: { replace?: boolean }) => void,
] {
  const [values, setValues] = useMultipleQueryParamStates({ names: [name] });

  const value = values[name];
  const setValue = useCallback(
    (newValue: string | undefined, options?: { replace?: boolean }) => {
      setValues({ [name]: newValue }, { replace: options?.replace });
    },
    [name, setValues],
  );

  return [value, setValue];
}
